import React from 'react'
import styles from "./reports-page.module.scss";
import { Sidebar } from '../../components/sidebar/sidebar';
import { Reports } from '../../features/reports/reports';


export const ReportsPage = () => {
  return (
    <div className={styles.page}>
      <Sidebar><Reports/></Sidebar>
      <div className={styles.content}>
        Здесь пока ничего нет
      </div>
    </div>
  )
}
